<template>
  <div>
    <el-row :gutter="30">
      <el-col :span=12>
        <ConfigSave :data="data"
                    :valid="valid"/>
      </el-col>
      <el-col :span=12>
        <el-button class="default"
                   size="small"
                   icon="el-icon-folder-opened"
                   @click="open">CONFIGURACIONES</el-button>
      </el-col>
    </el-row>
    <ConfigLoad ref="dialog"
                @apply="apply"/>
  </div>
</template>

<script>
import ConfigSave from './Save.vue';
import ConfigLoad from './Load.vue';

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    valid: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  name: 'ConfigPanel',
  components: {
    ConfigSave,
    ConfigLoad,
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    apply(configuration) {
      this.$emit('apply', configuration);
    },
  },
};
</script>

<style lang="scss" scoped>
  // styles
</style>
